import React, { useEffect, useState } from 'react';
import { Button, Card, CardContent, TablePagination } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import MUIDataTable from 'mui-datatables';
import { Edit, Visibility } from '@material-ui/icons';
import CustomeSearch from '../../../components/CustomSearch';
import ActiveFilter from '../../../components/ActiveFilter';
import ChecklistFormDialog from '../../../components/ChecklistFormDialog';
import FormDetailDialog from '../../../components/FormDetailDialog';
import {
  fetchSkyclimberForms,
  fetchSkyclimberFormDetail,
  addSkyclimberForm,
  editSkyclimberForm
} from '../../../redux/actions/safety';

const List = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [filterState, setFilterState] = useState({ isActive: '' });

  const dispatch = useDispatch();
  const { skyclimberForms, skyclimberFormDetail } = useSelector(({ safety }) => safety);

  const getFilterObj = (values) => ({
    isActive: values.isActive === '' ? undefined : values.isActive
  });

  useEffect(() => {
    dispatch(fetchSkyclimberForms({ page: 1, pageSize: 100, ...getFilterObj(filterState) }));
  }, []);

  const refresh = () => {
    dispatch(fetchSkyclimberForms({ page: 1, pageSize: 100, ...getFilterObj(filterState) }));
  };

  const columns = [
    { name: 'title', label: 'Title' },
    {
      name: 'safetyProject',
      label: 'Project',
      options: { customBodyRender: (value) => value?.name }
    },
    {
      name: 'isActive',
      label: 'Status',
      options: { customBodyRender: (value) => (value ? 'Active' : 'Inactive') }
    },
    {
      name: 'id',
      label: 'Actions',
      options: {
        customBodyRender: (value) => (
          <>
            <Visibility
              style={{ cursor: 'pointer' }}
              color="primary"
              onClick={() => {
                dispatch(fetchSkyclimberFormDetail(value));
                setIsDetailOpen(true);
              }}
            />
            <Edit
              style={{ cursor: 'pointer' }}
              color="primary"
              onClick={() => {
                dispatch(fetchSkyclimberFormDetail(value));
                setIsEditing(true);
                setIsFormOpen(true);
              }}
            />
          </>
        )
      }
    }
  ];

  return (
    <Card className="userlist">
      <ActiveFilter
        onFilter={(values) => {
          setFilterState(values);
          dispatch(fetchSkyclimberForms({ page: 1, pageSize: 100, ...getFilterObj(values) }));
        }}
        initialFormState={filterState}
      />
      <CardContent>
        <div className="userlist__header">
          <Button color="primary" variant="contained" onClick={() => { setIsEditing(false); setIsFormOpen(true); }}>
            New Skyclimber Form
          </Button>
        </div>
        <MUIDataTable
          title="Skyclimber Forms"
          data={skyclimberForms?.data || []}
          columns={columns}
          options={{
            filterType: 'textField',
            responsive: 'standard',
            selectableRows: 'none',
            pagination: false,
            elevation: 0,
            customSearchRender: (searchText, handleSearch, hideSearch) => (
              <CustomeSearch handleSearch={handleSearch} hideSearch={hideSearch} />
            ),
            customFooter: () => (
              <tbody>
                <tr>
                  <TablePagination
                    rowsPerPage={skyclimberForms?.pageSize || 100}
                    count={skyclimberForms?.count || 0}
                    page={skyclimberForms?.page ? skyclimberForms.page - 1 : 0}
                    onPageChange={(event, page) =>
                      dispatch(
                        fetchSkyclimberForms({
                          page: page + 1,
                          pageSize: skyclimberForms?.pageSize || 100,
                          ...getFilterObj(filterState)
                        })
                      )
                    }
                    onRowsPerPageChange={(event) =>
                      dispatch(
                        fetchSkyclimberForms({
                          page: 1,
                          pageSize: event.target.value,
                          ...getFilterObj(filterState)
                        })
                      )
                    }
                    rowsPerPageOptions={[10, 20, 40, 80, 100]}
                  />
                </tr>
              </tbody>
            ),
            print: false,
            viewColumns: false
          }}
        />
      </CardContent>

      {isFormOpen && (
        <ChecklistFormDialog
          open={isFormOpen}
          dialogTitle={isEditing ? 'Update Skyclimber Form' : 'New Skyclimber Form'}
          form={isEditing ? skyclimberFormDetail : null}
          onCreate={addSkyclimberForm}
          onUpdate={editSkyclimberForm}
          handleClose={() => {
            setIsFormOpen(false);
            setIsEditing(false);
          }}
          handleOk={() => {
            setIsFormOpen(false);
            setIsEditing(false);
            refresh();
          }}
        />
      )}
      {isDetailOpen && (
        <FormDetailDialog
          open={isDetailOpen}
          form={skyclimberFormDetail}
          handleClose={() => setIsDetailOpen(false)}
        />
      )}
    </Card>
  );
};

export default List;
